export const classificationData = [
    {
      id :'1',
      title: 'R&B',
    },
    {
      id : '2',
      title: 'Mood',
    },
    {
      id : '3',
      title: 'Latin',
    },
     
    {
      id:'4',
      title: 'Latin',
    },
    {
      id : '5',
      title: 'Chill',
    },
    
    {
      id : '6',
      title: 'Sleep',
    },
    
    {
      id : '7',
      title: 'Party',
    },
    
    {
      id : '8',
      title: 'Party',
    },
    
    {
      id : '9',
      title: 'Metal',
    },
    
    {
      id : '10',
      title: 'Jazz',
    },
    
    {
      id : '11',
      title: 'Trending',
    },
    
    {
      id : '12',
      title: 'Trending',
    },
    {
      id : '13',
      title: 'Soul',
    },
    {
      id : '14',
      title: 'Kids&Family',
    },
    {
      id : '15',
      title: 'Gaming',
    },
    {
      id : '16',
      title: 'Gaming',
    },
    {
      id : '17',
      title: 'Dance',
    },
    {
      id : '18',
      title: 'Electronic',
    },
    {
      id : '19',
      title: 'Chart',
    },
    {
      id : '20',
      title: 'Chart',
    },
  
  
  ]